import { Link } from "react-router-dom";
import { ArrowLeft, Lock } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { useI18n } from "@/i18n";
import PlatformIcon from "./PlatformIcon";

export default function PlatformGrid() {
  const { platforms } = useApp();
  const { t } = useI18n();

  return (
    <div
      className="grid grid-cols-2 sm:grid-cols-3 gap-4"
      data-testid="platform-grid"
    >
      {platforms.map((p, i) => {
        const inner = (
          <>
            <div
              className="w-14 h-14 rounded-2xl flex items-center justify-center mb-4 transition-transform group-hover:scale-110"
              style={{
                backgroundColor: `${p.color}1a`,
                color: p.color,
                border: `1px solid ${p.color}33`,
              }}
            >
              <PlatformIcon icon={p.icon} className="w-7 h-7" />
            </div>
            <div className="font-head font-bold text-base">{p.name}</div>
            <div className="text-xs text-muted-foreground mt-1 line-clamp-2 leading-relaxed">
              {p.enabled ? p.description : t("temporarily_unavailable")}
            </div>
          </>
        );

        if (!p.enabled || p.supported === false) {
          return (
            <div
              key={p.key}
              data-testid={`platform-card-disabled-${p.key}`}
              className="aran-card p-5 flex flex-col items-start relative opacity-60 cursor-not-allowed select-none"
            >
              <span className="absolute top-3 left-3 inline-flex items-center gap-1 text-[10px] text-amber-400/90 bg-amber-400/10 border border-amber-400/20 rounded-full px-2 py-0.5">
                <Lock className="w-3 h-3" />
                {t("temporarily_unavailable")}
              </span>
              {inner}
            </div>
          );
        }

        return (
          <Link
            key={p.key}
            to={`/${p.slug}`}
            data-testid={`platform-card-${p.key}`}
            className="aran-card aran-card-hover p-5 flex flex-col items-start group animate-fade-up"
            style={{ animationDelay: `${i * 60}ms` }}
          >
            {inner}
            <span className="mt-4 inline-flex items-center gap-1 text-xs font-semibold text-primary">
              {t("choose_tool")}
              <ArrowLeft className="w-3.5 h-3.5" />
            </span>
          </Link>
        );
      })}
    </div>
  );
}
